<script lang="ts">
    import { push } from "svelte-spa-router";
    import { onMount } from "svelte";

    import type { LoginForm } from "../../types/login";
    import { ROUTES } from "../../helpers/routes";
    import {
        getLocalStorageByKey,
        setLocalStorage,
    } from "../../helpers/localstorage";

    import Logo from "../../assets/logo.svg";
    import { userLogin } from "../../api/callers";

    const loginForm: LoginForm = {
        email: "",
        password: "",
    };

    onMount(() => {
        const userToken = getLocalStorageByKey("USER_TOKEN");
        if (userToken) {
            push(ROUTES.HOME);
        }
    });

    async function onLogin(e: MouseEvent) {
        e.preventDefault();
        try {
            const response = await userLogin(loginForm);
            setLocalStorage("USER_TOKEN", response.token);
            push(ROUTES.HOME);
        } catch (error) {
            console.log(error);
        }
    }
</script>

<div class="login_container">
    <div class="logo">
        <Logo />
    </div>
    <div class="form">
        <h2 class="title">Login to your account</h2>
        <form>
            <label for="email">Enter your email</label>
            <input
                autocomplete="email"
                id="email"
                type="text"
                bind:value={loginForm.email}
            />
            <label for="password">Enter your password</label>
            <input
                autocomplete="current-password"
                type="password"
                bind:value={loginForm.password}
            />
            <button on:click={onLogin}>Login</button>
        </form>
    </div>
</div>

<style lang="scss">
    @import "./login.scss";
</style>
